import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "Cast uitzetten"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3 18v2.5h2.6C5.6 19.1 4.4 18 3 18zm0-3.5v1.7c2.4 0 4.3 2 4.3 4.3H9a6 6 0 0 0-6-6zM3 11v1.8c4.3 0 7.8 3.5 7.8 7.7h1.7c0-5.2-4.3-9.5-9.5-9.5zm1.7-6H3v4.3h1.7V6.7h15.6v12.1h-6v1.7H22V5H4.7z"
})));